import { formatCurrency } from '@/utils/numberFormat';

export const formatReportsMetricValue = (value, format) => {
  const normalizedFormat = String(format || '').trim().toLowerCase();
  const numericValue = Number(value || 0);

  if (value === null || value === undefined || value === '') {
    return '-';
  }

  if (normalizedFormat === 'currency') {
    return formatCurrency(numericValue, { currency: 'MXN' });
  }

  if (normalizedFormat === 'percentage') {
    const rounded = Math.round(numericValue * 100) / 100;
    return `${rounded}%`;
  }

  if (normalizedFormat === 'number') {
    return String(Math.round(numericValue * 100) / 100);
  }

  return String(value);
};
